import {Button, Form, Input} from "antd";
import {LockOutlined} from "@ant-design/icons";
import React from "react";

interface ChangePasswordFormProps {
    setPassword: (password: string) => void,
    handleSavePassword: () => void
}

const ChangePasswordForm = (
    {
        setPassword,
        handleSavePassword,
    }: ChangePasswordFormProps
) => {
    return (
        <Form
            name="login_form"
            initialValues={{remember: true}}
            onFinish={() => {
            }}
            layout="vertical"
            size="large"
        >
            <Form.Item
                label="Пароль"
                name="password"
                rules={[
                    {required: true, message: 'Введите пароль!'},
                    { min: 6, message: "Пароль должен содержать минимум 6 символов" },
                ]}
                hasFeedback
            >
                <Input.Password prefix={<LockOutlined/>} placeholder="Пароль"
                                onChange={(e) => setPassword(e.target.value)}/>
            </Form.Item>

            <Form.Item
                name="confirm"
                label="Подтвердите пароль"
                dependencies={['password']}
                hasFeedback
                rules={[
                    { required: true, message: "Подтвердите пароль" },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error("Пароли не совпадают"));
                        },
                    }),
                ]}
            >
                <Input.Password prefix={<LockOutlined/>} placeholder="Пароль"/>
            </Form.Item>

            <Form.Item style={{marginTop: 24}}>
                <Button type="primary" htmlType="submit" block onClick={handleSavePassword}>
                    Сохранить
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ChangePasswordForm;